import axios from "axios"
import _some from "lodash/some"
import _includes from "lodash/includes"

import * as Auth from "services/network/auth"
import ENV from "../../../../../envProperties"
import { sendGtmEventError } from "services/utils/sendGtm"

const HTTP_REQUEST_HEADER = {
  "Content-Type": "application/json",
  "x-app-origin": "portal-b2b"
}

const ROUTES_FOR_ANALYTICS = [
  "/product/all",
  "/v2/billing/invoices/historic",
  "/v2/billing/invoices/summary",
  "/support/open-ticket"
]

export const BASE_URL = `${ENV.BFF}`
const APP_BASENAME = "/AreaClienteCorporativo"
const AUTH_REDIRECT_FLAG = "bffAuthRedirectInProgress"

const instance = axios.create({
  baseURL: BASE_URL,
  headers: HTTP_REQUEST_HEADER
})

const interceptors = { request: [], response: [] }

function getPendingPromise() {
  return new Promise(() => {})
}

function isAuthRedirectInProgress() {
  return window.sessionStorage.getItem(AUTH_REDIRECT_FLAG) === "true"
}

function startAuthRedirect() {
  if (isAuthRedirectInProgress()) {
    return getPendingPromise()
  }

  const pathname = window.location.pathname.startsWith(APP_BASENAME)
    ? window.location.pathname.slice(APP_BASENAME.length) || "/"
    : window.location.pathname
  const returnTo = `${pathname}${window.location.search}${window.location.hash}`
  const loginLocation = `${window.location.origin}/AreaClienteCorporativo/login`

  window.sessionStorage.setItem("postLoginRedirectPath", returnTo)
  window.sessionStorage.setItem(AUTH_REDIRECT_FLAG, "true")
  window.location.replace(
    `${ENV.BFF}/auth/oauth2/authorization?location=${loginLocation}`
  )

  return getPendingPromise()
}

function registerEventResponseAjaxNewRelic(response, error) {
  const currentUrlGateway = error
    ? error.config.url
    : response
    ? response.config.url
    : ""

  if (
    !_some(ROUTES_FOR_ANALYTICS, (route) => _includes(currentUrlGateway, route))
  ) {
    return
  }

  if (!window.newrelic) return

  if (error) {
    window.newrelic.addPageAction("ajaxBodyTrace", {
      type: "response",
      url: currentUrlGateway,
      method: error.config.method,
      requestData: error.config.data || "",
      requestQueryParams: error.config.params
        ? JSON.stringify(error.config.params)
        : "",
      statusResponse: error.response.status
    })

    return
  }

  if (response) {
    window.newrelic.addPageAction("ajaxBodyTrace", {
      type: "response",
      url: currentUrlGateway,
      method: response.config.status,
      requestData: response.config.data || "",
      requestQueryParams: response.config.params
        ? JSON.stringify(response.config.params)
        : "",
      statusResponse: response.request.status,
      responseData: response.request.response
    })
  }
}

interceptors.request.push({
  success: (unused, request) => {
    request.headers.Authorization = Auth.getAuthorizationBff()

    const currentUrlGateway = request.url

    if (
      _some(ROUTES_FOR_ANALYTICS, (route) =>
        _includes(currentUrlGateway, route)
      )
    ) {
      if (window.newrelic) {
        window.newrelic.addPageAction("ajaxBodyTrace", {
          type: "request",
          url: currentUrlGateway,
          method: request.method,
          requestData: request.data || "",
          requestQueryParams: request.params
            ? JSON.stringify(request.params)
            : ""
        })
      }
    }

    return request
  },

  error: (unused, error) => Promise.reject(error)
})

interceptors.response.push({
  success: (_, response) => {
    registerEventResponseAjaxNewRelic(response, null)
    return response
  },

  error: (_, error) => {
    registerEventResponseAjaxNewRelic(null, error)

    if (isAuthRedirectInProgress()) {
      return getPendingPromise()
    }

    if (error.response && error.response.status === 401) {
      return startAuthRedirect()
    }

    sendGtmEventError(error.response.status, error.response.data)

    return Promise.reject(error)
  }
})

export default { client: instance, options: { interceptors } }



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/bff.js